<template>
    <div class="innerBox">
  
      	<h1 class="mb-3">Supplier Report</h1>
  
      	<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox" style="padding:0%">
				<div class="col row">
					<div class="col-md-3 col-12 mt-1">
						<label>Supplier</label>
						<Multiselect 
							:options="supplierList.map(x => x.id)"
							:custom-label="opt => supplierList.find(x => x.id == opt).name"
							v-model="filter.supplier"
						/>
					</div>
					<div class="col-md-3 col-12 mt-1" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tanggal</label>
						<DatePicker
							class="w-100"
							v-model="selected.date"
							type="monthrange"
							align="right"
							format="MMM yyyy"
							range-separator="-"
							start-placeholder="Start"
							end-placeholder="End"
							:picker-options="pickerOptions"
							style="height:43px">
						</DatePicker>
					</div>
					<div class="col-md-3 col-12 mt-1">
						<label>Status Barang</label>
						<Multiselect 
							:options="status"
							v-model="filter.status"
						/>
					</div>
					<div class="col-md-3 col-12 mt-1" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
					<button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="updateFilter">Filter</button>
					</div>
				</div>
			</div>
      	</panel>

		<div class="row">
			<div class="col-md-5 col-12">
				<smallStats 
					title="Total Payment"
					:value="
						statsData
							? 'Rp. ' + 
							numberWithCommas(
									parseFloat(statsData.total_payment)
							)
							: 'Loading...'
					"
					background_color="#FF3357"
					icon="money-check"
					text_color="#fff"
				/>
			</div>
			<div class="col-md-7 col-12">
				<div class="row">
					<div class="col-md">
						<smallStats 
							title="Sudah Dibayar"
							:value="
								statsData
									? 'Rp. ' +
									numberWithCommas(
											parseFloat(statsData.paid_sparepart)
									)
									: 'Loading...'
							"
							background_color="#FF5733"
							icon="receipt"
							text_color="#fff"
						/>
					</div>
					<div class="col-md">
						<smallStats 
							title="Belum Dibayar"
							:value="
								statsData
									? 'Rp. ' +
									numberWithCommas(
											parseFloat(statsData.pending_payment_sparepart)
									)
									: 'Loading...'
							"
							background_color="#2ea34b"
							text_color="#fff"
							icon="credit-card"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="row ">
			<div class="col-md-5 col-12 mt-2">
				<smallStats 
					title="Total Sparepart"
					:value="
						statsData
							? 
							numberWithCommas(
									parseInt(statsData.total_sparepart)
							)
							: 'Loading...'
					"
					:sub_value="
						`Beli : ${numberWithCommas(statsData.total_sparepart_purchased)} ; Supply : ${numberWithCommas(statsData.total_sparepart_supplied)}`
					"
					background_color="#2949B9"
					text_color="#fff"
					icon="tools"
				/>
			</div>
			<div class="col-md-7 col-12">
				<div class="row">
					<div class="col-md mt-2">
						<smallStats 
							title="Sparepart Datang"
							:value="
								statsData
									? 
									numberWithCommas(
											parseFloat(statsData.sparepart_sudah_datang)
									)
									: 'Loading...'
							"
							background_color="#F59C19"
							text_color="#fff"
							icon="container-storage"
						/>
					</div>
					<div class="col-md mt-2">
						<smallStats 
							title="Sparepart Belum Datang"
							:value="
								statsData
									? 
									numberWithCommas(
											parseFloat(statsData.sparepart_belum_datang)
									)
									: 'Loading...'
							"
							background_color="#8F00FF"
							text_color="#fff"
							icon="truck-loading"
						/>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="row mt-2">
			<div class="col-md-3">
				<smallStats 
					title="Beli Sparepart"
					:value="
						statsData
							? 
							numberWithCommas(
									parseFloat(statsData.total_sparepart_purchased)
							)
							: 'Loading...'
					"
					background_color="#49B6D6"
					text_color="#fff"
					icon="box-usd"
				/>
			</div>
			<div class="col-md-3">
				<smallStats 
					title="Supply Sparepart"
					:value="
						statsData
							? 
							numberWithCommas(
									parseFloat(statsData.total_sparepart_supplied)
							)
							: 'Loading...'
					"
					background_color="#AAAADD"
					text_color="#fff"
					icon="truck-container"
				/>
			</div>
			
		</div> -->
  
		<vue-universal-table
			class="mt-3"
			api_url="/api/v1/masterData/supplier/report"
			:disable_sort="true"
			:update="vue_universal_table.update"
			:filter="filter"
			:page="filter.page"
			@getCurrentPage="updatePage"
			:fields="vue_universal_table.fields"
			:process_data="vue_universal_table.process_data"
		></vue-universal-table>

  
    </div>
  </template>
  
  <script>  
	import Multiselect from 'vue-multiselect'
	import moment from 'moment'

	import { DatePicker } from 'element-ui'
	import lang from 'element-ui/lib/locale/lang/en'
	import locale from 'element-ui/lib/locale'
	locale.use(lang)

	import modalView from './children/modalView'
	import smallStats from '@/components/smallStats'

	import qs from 'qs'
    export default {
	    components : {
			DatePicker,
			Multiselect,
			modalView,
			smallStats
		},
		watch: {
			"selected.date"() {
				this.filter.start = new moment(this.selected.date[0]).startOf('month').format('Y-MM-DD')
				this.filter.end = new moment(this.selected.date[1]).endOf('month').format('Y-MM-DD')
			}
		},
		data () {
			const start = moment().subtract(4 , 'months').startOf('month').format('YYYY-MM-DD');
			let end  = new moment().endOf('month').format('YYYY-MM-DD')

			let startFilter = new Date().setMonth(new Date().getMonth() - 4)
			let endFilter = new Date()
			let filter = {}
			if(!this.$route.query.start) {
				filter = {
					start : start,
					end : end,
					supplier : null,
					status : null,
					page : 1
				}

				history.pushState({},
					null,
					this.$route.path +
					'?' +
					Object.keys(filter)
						.map(key => {
						return (
							encodeURIComponent(key) + '=' + encodeURIComponent(filter[key])
						)
						})
						.join('&')
				)
			}
			else {
				let obj = this.$route.query
				console.log(obj)
				// obj.forEach(element => {
				// 	if(obj[element] == 'null') obj[element] = null
				// });
				for(let key in obj) {
					if(obj[key] == 'null') obj[key] = null
				}
				filter = obj
				startFilter = new Date(obj.start)
				endFilter = new Date(obj.end)

				
			}

			return {
				mobile : this.isMobile(),
				statsData : null,
				modal : {
					view : false,
				},
				rangeConfig: {
					mode: 'range',
					altInput: true,
					altInputClass: 'form-control input flatpickr-input w-100',
					animate: !this.isRTL()
				},
				detailId : '',
				options : this.$store.getters.getFilterOptions,
				status : ['Barang Belum Datang', 'Barang Sudah Datang', 'Voucher Belum Dibikin' , 'Menunggu Pembayaran','Pembayaran Selesai'],
				filter : filter,
				selected : {
					date : [
						startFilter,
						endFilter
					]
				},
				supplierList : this.$store.getters.getSupplier,
				pickerOptions: {
					shortcuts: [{
						text: 'Bulan Ini',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					}, {
						text: 'Tahun Ini',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '6 Bulan Terakhir',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				vue_universal_table : {
					fields : [
						{
							title : 'Nomor Wo',
							variable : 'work_order_code'
						},
						
						{
							title : 'Supplier',
							variable : 'supplier_name'
						},
						{
							title : 'Nama Sparepart',
							variable : 'sparepart_name'
						},
						{
							title : 'Deskripsi',
							variable : 'description'
						},

						{
							title : 'Jumlah',
							variable : 'amount',
							number_formatting : true
						},
						{
							title : 'Harga per Item',
							variable : 'price_per_item',
							number_formatting : true
						},
						{
							title : 'Total Harga',
							variable : 'total_purchased_item',
							number_formatting : true
						},
						{
							title : 'Tgl Sampai',
							variable : 'item_arrived_date',
							// style_condition : {
							// 	'In Progress' : 'color : #C6A700',
							// 	'Done' : 'color : #00B14B',
							// 	'Open' : 'color : #E02525',
							// 	'Expired' : 'color:#A3A3A3',
							// }
							style_condition : {
								'Belum Datang' : 'color : #FF5733;font-weight:bold',
							}
						},
						// {
						// 	title : 'Barcode',
						// 	variable : 'barcode',
						// },
						{
							title : 'Pembayaran',
							variable : 'payment_status',
							style_condition : {
								'Barang Disupply' : 'color : #C6A700;font-weight:bold',
								'Belum Dibayar' : 'color : #E02525;font-weight:bold',
								'Sudah Dibayar' : 'color : #00B14B;font-weight:bold',
							}
						}
					],
					special_buttons : ['exportToExcel'],
					buttons : [{
						title : 'SupplierDetail',
						class : 'btn btn-outline-primary fas fa-eye'
					}],
					process_data : `
						for(var i = 0 ; i < data.length ; i++) {
							if(data[i].item_arrived_date != 'Belum Datang')
								data[i].item_arrived_date = this.moment(data[i].item_arrived_date).format('MMM DD, Y HH:mm')

							let datePembayaran = this.moment(data[i].payment_status , 'YYYY-MM-DD' , true)

							if(datePembayaran.isValid()) {
								data[i].payment_status = 'Paid - ' + datePembayaran.format('MMMM DD,Y')
							}
						}
					`,
					update : 0,
					export_config : {
					name : 'Supplier Report',
					type : 'xlsx',
					all : true
					},
				},
				dummyData : null,
			}
		},
      mounted () {
		this.getStats()
      },
      methods : {
			getStats () {
				let url = '/api/v1/masterData/supplier/report/stats?'
				this.$http.get(url + this.initialiseFilter(this.filter))
				.then((resp) => {
					// this.statsData = resp.data.data
					this.$set(this , 'statsData' , resp.data.data[0])
				})
				.catch((err) => {
					console.log(err)
				})
			},
			updateFilter() {
				this.updateHistory()
				this.getStats()
				this.vue_universal_table.update++
			},
			updatePage (page) {
				this.filter.page = page
				this.updateHistory()
				
			},
			updateHistory () {
				history.pushState({},
					null,
					this.$route.path +
					'?' +
					Object.keys(this.filter)
						.map(key => {
						return (
							encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key])
						)
						})
						.join('&')
				)
			}
      }
    }
  </script>
  
  <style scoped>
  
  </style>